<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'monitoringManageplugInMonitoring' }">直连插件监控器</el-breadcrumb-item>
      </el-breadcrumb-item>
      <el-breadcrumb-item>查看SQL</el-breadcrumb-item>
    </el-breadcrumb>
    <h1 class="view-head">
      查看SQL
    </h1>
    <div class="view-content">
      <el-card>
        <el-switch
          v-model="is_old"
          @change="handleSwitchChange"
          active-text="老插件"
          inactive-text="新插件">
        </el-switch>
      </el-card>
      <el-tabs type="border-card" style="margin-top: 20px;" @tab-click="tabClick">
        <el-tab-pane label="连接设置">
          <div class="connect-set">
            <p><span class="fieldType">数据库类型：</span><span class="parameter">{{pluginInfo.DataSourceType}}</span></p>
            <p><span class="fieldType">数据库地址：</span><span class="parameter">{{pluginInfo.DataSourceaddress}}</span></p>
            <p><span class="fieldType">数据库端口：</span><span class="parameter">{{pluginInfo.DataSourcport}}</span></p>
            <p><span class="fieldType">数据库名称：</span><span class="parameter">{{pluginInfo.DataSourcName}}</span></p>
            <p><span class="fieldType">用户名：</span><span class="parameter">{{pluginInfo.DataSourcLoginName}}</span></p>
            <p><span class="fieldType">密码：</span><span class="parameter">{{pluginInfo.DataSourcPassword}}</span></p>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="item.report_type_label" v-for="(item,index) in reportList" :key="item.report_type">
          <div class="connect-set">
            <p><span class="fieldType">SQL语句：</span></p>
            <el-input type="textarea" v-model="reportList[index].sql" :disabled="true" :rows="12" @change="textareaChange(index)">{{item.sql}}</el-input>
          </div>
          <!-- <el-button type="primary" @click="onSync(index)" style="margin-top:10px;"
                     :disabled="item.sql_log&&item.sql_log.length!=[]&&item.sql_log.length!=''&&(item.sql_log[0].status==1||item.sql_log[0].status==2)"
          >{{item.sql_log&&item.sql_log!=''&&(item.sql_log[0].status==1||item.sql_log[0].status==2)?'同步中...':'同步'}}</el-button>
          <p style="color: #B4B6B8;padding: 15px 0px 5px 0;font-size: 14px;">同步后这个报告类型的SQL会同步给直连插件</p> -->
        </el-tab-pane>

      </el-tabs>
      <el-card class="box-card" style="margin-top: 20px;" v-if="tabIndex!=-1">
        <h4 style="margin-bottom: 15px;">同步日志</h4>
        <div class="table-tool">共{{sql_log&&sql_log.length}}条</div>
        <el-table
          :data="sql_log"
          height="400"
          style="width: 100%">
          <el-table-column
            prop="create_time"
            label="操作时间">
          </el-table-column>
          <!--
          交互说明：
          1.企业流连宝的同步日志中，删除操作人一列
          -->
          <!--<el-table-column
            prop="account_name"
            label="操作人">
          </el-table-column>-->
          <el-table-column
            prop="status"
            label="状态">
            <template slot-scope="scope">
              <span>{{{1:'等待中',2:'进行中',3:'成功',4:'sql有误'}[scope.row.status]}}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>
    <el-dialog
      title="提示!"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <span>确认将这段SQL同步到插件？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm" :loading="loading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {pluginGetTemporary,set_temporary} from '@/api/index';
//定时器声明
var t2 = null;
// 缺省报告类型添加
function addDefaultReportType(list) {
  let defaultReportTypeList = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  let reportTypeList = [];
  let reportTypeMap = {
    1: '销售日报',
    2: '采购日报',
    3: '库存日报',
    4: '销售周报',
    5: '采购周报',
    6: '库存周报',
    7: '销售月报',
    8: '采购月报',
    9: '库存月报'
  };

  for (let item of list) {
    reportTypeList.push(item.report_type);
  }
  let notIncludeReportTypeList = defaultReportTypeList.filter(item => reportTypeList.indexOf(item) === -1);
  for (let item of notIncludeReportTypeList) {
    let obj = {
      report_type: item,
      report_type_label: reportTypeMap[item],
      sql: ''
    };
    list.push(obj);
  }
}

export default {
  name: "monitoringParticularsTabs",
  beforeCreate() {
    this.monitoring = this.$route.params;
  },
  data: () => ({
    reportList: [],
    pluginInfo: {},
    form:{},
    currentPage: 1,
    totalCount: 0,
    totalPage: 0,
    tableData: [],
    status: true,
    dialogVisible: false,
    loading: false,
    sql_log: [],
    submitIndex:-1,
    tabIndex:-1,
    is_old: false
  }),
  created() {
    this.getDetails();
    let that = this;

    //定义全局定时器，每3分钟调用一次获取详情
    t2 = window.setInterval(function() {
      that.getDetails();
    },180000)
  },
  methods: {
    // 切换插件类型
    handleSwitchChange(value) {
      console.log(value)
      this.getDetails();
    },
    /*
    * 获取详情数据
    * */
    getDetails(){
      //商业公司编码
      const {client_code} = this.$route.params;
      this.client_code = client_code;
      let parameter={
        client_code,
        plugin_code: this.monitoring.plugin_code,
        is_new: this.is_old ? 0 : 1
      }
      pluginGetTemporary(parameter).then(res => {
        let reportList = [];
        if (0 === res.status) {
          let data = res.data;
          this.isClick = res.data[0];
          console.log(this.isClick )
          for (let item of data) {
            switch (item.report_type) {
              case 0:
                item.report_type_label = '连接配置';
                break;
              case 1:
                item.report_type_label = '销售日报';
                break;
              case 2:
                item.report_type_label = '采购日报';
                break;
              case 3:
                item.report_type_label = '库存日报';
                break;
              case 4:
                item.report_type_label = '销售周报';
                break;
              case 5:
                item.report_type_label = '采购周报';
                break;
              case 6:
                item.report_type_label = '库存周报';
                break;
              case 7:
                item.report_type_label = '销售月报';
                break;
              case 8:
                item.report_type_label = '采购月报';
                break;
              case 9:
                item.report_type_label = '库存月报';
                break;
            }
          }
          console.log(data)
          let target = data.filter(item => item.report_type === 0)[0];
          reportList = data.filter(item => item.report_type !== 0);
          if(target){
            let pluginInfo = JSON.parse(target.sql);
            this.pluginInfo = pluginInfo;
          }
        } else {
          this.pluginInfo = {};
          reportList = [];
        }
        addDefaultReportType(reportList);
        // 排序
        reportList.sort((a, b) => {
          return a.report_type - b.report_type;
        });
        this.reportList = reportList;
        this.originalReportList = JSON.parse(JSON.stringify(reportList));
        if(reportList[this.tabIndex]&&reportList[this.tabIndex].sql_log){
          let sql_log = reportList[this.tabIndex].sql_log;
          for (let i = 0; i < sql_log.length; i++) {
            sql_log[i].create_time = sql_log[i].create_time.substring(0, 16);
          }
          this.sql_log = sql_log;
        }else{
          this.sql_log = [];
        }
      })
    },
    onSync(index){
      this.dialogVisible = true;
      this.submitIndex = index;
    },
    confirm(){
      this.loading = true;
      let reportList = this.reportList;
      let monitoring = this.monitoring;
      let tempData = reportList[this.submitIndex];
      let arr = [];
      if(tempData.sql!=this.originalReportList[this.submitIndex].sql){
        arr = [{
          report_type:tempData.report_type,
          client_code:monitoring.client_code,
          plugin_code:monitoring.plugin_code,
          sql:tempData.sql,
          is_new: this.is_old ? 0 : 1
        }];
      }
      console.log(arr);
      if(arr[0]&&arr[0].sql == ''){
        this.$message.warning('SQL不能为空！');
        this.loading = false;
        return
      }
      if(arr.length == 0){
        this.$message.warning('请编辑后再同步！');
        this.loading = false;
        return
      }
      set_temporary(JSON.stringify(arr)).then(res => {
        this.status = false;
        if (0 === res.status) {
          this.getDetails();
          this.$message({
            message: res.msg,
            type: 'success'
          });
        }else{
          this.$message.error(res.msg);
        }
        this.loading = false;
        this.status = true;
        this.dialogVisible = false;
      });
    },
    tabClick(tab) {
      this.tabIndex = tab.index-1;
      if(this.reportList[tab.index-1]&&this.reportList[tab.index-1].sql_log){
        let sql_log = this.reportList[tab.index-1].sql_log;
        for (let i = 0; i < sql_log.length; i++) {
          sql_log[i].create_time = sql_log[i].create_time.substring(0, 16);
        }
        this.sql_log = sql_log;
      }else{
        this.sql_log = [];
      }
      console.log(this.sql_log)
      // console.log(this.reportList[tab.index-1])
    },
    textareaChange(index){
      this.reportList[index].isRedact = true;
      console.log(index)
    }
  },
  destroyed: function () {
    //关闭页面是清除定时器
    window.clearInterval(t2);
  },
}
</script>

<style scoped lang="scss">
.box-card {
  margin-bottom: 20px;
}

.connect-set {
  p {
    padding: 10px 0;
  }

  span {
    display: inline-block;
  }

  .fieldType {
    width: 115px;
    text-align: left;
  }

  .parameter {
    color: #A4A5A6;
  }
}

.sql-statement {
  box-sizing: border-box;
  width: 100%;
  border: 1px solid #EBEBEB;
  border-radius: 5px;
  min-height: 300px;
  padding: 0px 15px;
  word-wrap: break-word;
}

.box-card {
  margin-bottom: 20px;
}

.plug-tag .label {
  margin-right: 10px;
  display: inline-block;
  vertical-align: middle;
}

.plug-tag .label-value {
  display: inline-block;
  margin-right: 60px;
  color: #A4A5A6;
  max-width: 204px;
  white-space: nowrap;
  word-break: keep-all;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}
</style>